import React from "react";
import { cn } from "../../../common/u1/cn";
import { PanelCard } from "./PanelCard";
import { BenefitItem } from "./BenefitItem";
import { ClockIcon } from "../../../../assets/ui/icons";
import { HAVE_BENEFITS } from "../../Dashboard/membership/membershipContent";

/* The left-hand panel: what an active membership is already doing. */

/* "31 Dec 2024". en-GB rather than the viewer's locale so the day and month
   cannot swap places on a date people read as a deadline. */
export const formatRenewalDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const MembershipPanel = ({
  eyebrow = "Active",
  title = "Your membership",
  intro = "You're a paying member — these are working for you right now.",
  benefits = HAVE_BENEFITS,
  /* Named so the line reads as this company's plan, not a generic one. */
  companyName,
  /* The membership's next billing date. Absent today — CompanyMembership
     carries `current_period_end` but nothing serialises it — so the line is
     drawn only when a real date arrives rather than inventing one. */
  renewalDate,
  className = "",
}) => {
  const renewal = formatRenewalDate(renewalDate);

  return (
    <PanelCard accent="gold" eyebrow={eyebrow} title={title} intro={intro} className={className}>
      <div className="flex flex-col gap-4">
        {benefits.map((b) => (
          <BenefitItem key={b.title} title={b.title} body={b.body} tone="active" />
        ))}
      </div>

      {/* mt-auto: the two panels share a height now, so this sits on the
          panel's floor instead of floating under the last benefit. */}
      <div className="mt-auto pt-[22px]">
        <p className="m-0 mb-2 text-[12.5px] font-semibold text-[var(--muted)] font-sans">
          Membership Status &amp; Management
        </p>
        <div
          className={cn(
            "flex items-start gap-3 rounded-xl border border-[var(--line)]",
            "bg-[var(--slate-2)] px-3.5 py-3"
          )}
        >
          <span
            aria-hidden="true"
            className="mt-[2px] flex shrink-0 text-[var(--muted)]"
          >
            <ClockIcon size={15} />
          </span>
          <p className="m-0 text-[13px] leading-[1.55] text-[var(--ink-2)] font-sans">
            Your Premium Business plan is active. All benefits enabled
            {companyName ? ` for ${companyName}` : ""}.
            {renewal && (
              <>
                <br />
                Renewal date: {renewal}
              </>
            )}
          </p>
        </div>
      </div>
    </PanelCard>
  );
};

export default MembershipPanel;
